import { z } from 'zod';

/** @see AppleRetail.Web.ApiControllers.ShopProductSelectionApiController.ProductSelectionResult */
export const productSelectionResponseSchema = z.object({
	productIds: z.array(z.string()),
	quantities: z.record(z.string(), z.number()).default({}),
});

export type ProductSelectionResponse = z.infer<typeof productSelectionResponseSchema>;
